export const navRoute = ["dashboard", "Members"];
export const urlRoute = [
  "dashboard",
  "user.users",
  "user.users.profile",
];
